import script from "./ShadowSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShadowSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ShadowSettings.scss?vue&type=style&index=0&id=b75ea174&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75ea174"]])

export default __exports__